import React from 'react';
import {BADGE_COLOR} from "../../../utils/constants";
import HighlightedText from "../HighlightedText/HighlightedText";
import {LinkButton} from "../LinkButton";

interface OrganizationCardProps {
  imageUrl: string;
  categories: string[];
  title: string;
  region: string;
  address: string;
  phone: string;
  url: string;
  keyword?: string;
  appointmentWeb?: string;
  progressWeb?: string;
  handleClickOnCard?: () => void;
}

export const OrganizationCard = ({
  imageUrl,
  categories,
  title,
  region,
  address,
  phone,
  keyword = '',
  appointmentWeb = '',
  progressWeb = '',
  handleClickOnCard = () => null,
}: OrganizationCardProps) => {
  const handleClickOnAppointmentWebLink = () => window.open(appointmentWeb, '_blank');
  const handleClickOnProgressWebLink = () => window.open(progressWeb, '_blank');

  return (
    <div
      onClick={handleClickOnCard}
      className={`
        cursor-pointer rounded-lg shadow-lg transition-all duration-200 my-2 p-4 bg-gradient-to-br 
        from-white via-white to-white border border-gray-100 flex active:scale-95
      `}
    >
      {/* Image Section */}
      <div className="w-5/12 pr-4">
        <img
          src={imageUrl}
          alt={title}
          className="rounded-lg object-cover w-full h-auto aspect-[4/3]"
        />
      </div>

      {/* Content Section */}
      <div className="w-2/3 flex flex-col gap-y-3">
        {/* Top Section */}
        <div>
          <h3 className="text-xl font-bold text-gray-800">{HighlightedText({ content: title, keyword })}</h3>
          <div className="flex flex-row flex-wrap mt-1">
            {categories?.length > 0 && categories.map((category, index) => (
              <div
                key={`category-${index}`}
                className={`
                  text-sm mr-2 mb-1 py-0.5 px-2 text-white rounded-lg 
                  ${BADGE_COLOR[category].color}
                `}>
                {category}
              </div>
            ))}
            <div className="text-sm mb-1 py-0.5 px-2 text-purple-500 rounded-lg border border-purple-500">
              {region}
            </div>
          </div>
        </div>
        {/* Details Section */}
        <div>
          <p className="text-sm text-gray-600">
            <strong>地址:</strong> {HighlightedText({ content: address, keyword })}
          </p>
          <p className="text-sm text-gray-600">
            <strong>電話:</strong> {phone}
          </p>
        </div>
        <div className="flex flex-row gap-x-2">
          {appointmentWeb ? <LinkButton onClick={handleClickOnAppointmentWebLink} label="前往掛號" /> : null}
          {progressWeb ? <LinkButton onClick={handleClickOnProgressWebLink} label="查看看診進度" /> : null}
        </div>
      </div>
    </div>
  );
};
